import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import AuditAction from '@/audit//components/AuditAction';
import { states } from '@/constants/lifecycle';
import { searchUrl } from '@/constants/urls';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import SaveAction from './SaveSearchAction';
import DuplicateSearchAction from './DuplicateSearchAction';
import ShareSearchAction from '../sharing/containers/ShareSearchAction';
import { refreshFind, confirmSearchDeletion } from '../actions';
import { searchPermissions } from '../constants';

const SearchActions = ({
  code,
  category,
  isNew,
  readStatus,
  allowRefresh,
  allowShare,
  allowSave,
  allowDelete,
  allowSecure,
  refresh,
  showDelete,
  allowAudit,
  url,
}) => (
  <>
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, code)} readStatus={readStatus} />)}
    {allowSave && (<SaveAction code={code} category={category} />)}
    {allowSave && !isNew && (<DuplicateSearchAction code={code} category={category} />)}
    {(allowShare || allowSecure) && !isNew && (
    <ShareSearchAction code={code} category={category} secureOnly={allowSecure && !allowShare} />
    )}
    {allowAudit && !isNew && (<AuditAction baseUrl={url} />)}
    {allowDelete && !isNew && (
    <DeleteActionMenu onClick={() => showDelete(category, code)} disabled={readStatus === states.PENDING} />
    )}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  search: { searches },
}, { category, code }) => {
  const search = findResult(searches, category, code);
  const isNew = search ? search.isNew : true;
  const allowSave = isNew
    ? permissions.search.create
    : permissions.search.update && search && search.permissions[searchPermissions.UPDATE];

  return {
    readStatus: search ? search.readStatus : states.NONE,
    isNew,
    allowRefresh: permissions.search.run,
    allowShare: permissions.search.share && search && (search.permissions[searchPermissions.INVITE_MEMBER]
            || search.permissions[searchPermissions.REMOVE_MEMBER]),
    allowSave,
    allowDelete: permissions.search.destroy && search && search.permissions[searchPermissions.DESTROY],
    allowSecure: permissions.search.secure && search && search.permissions[searchPermissions.SECURITY],
    allowAudit: permissions.search.audit && search && search.permissions[searchPermissions.AUDIT],
    url: search ? searchUrl(search, '#') : '',
  };
};

const mapDispatchToProps = {
  refresh: (category, code) => refreshFind(category, code, 1),
  showDelete: confirmSearchDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchActions);
